
import { useQuery } from '@tanstack/react-query';
import { fetchPremiumBotById } from '@/services/premium-bot';
import { useAuth } from '@/contexts/AuthContext';
import { useState } from 'react';
import { toast } from 'sonner';

export const usePremiumBotDetail = (botId: string | undefined) => {
  const { user } = useAuth();
  const [isSubscribing, setIsSubscribing] = useState(false);
  const [subscriptionSuccess, setSubscriptionSuccess] = useState(false);

  const { 
    data: premiumBot, 
    isLoading, 
    error,
    refetch
  } = useQuery({
    queryKey: ['premiumBotDetail', botId, user?.id],
    queryFn: async () => {
      if (!botId || !user?.id) return null;
      return fetchPremiumBotById(botId, user.id);
    },
    enabled: !!botId && !!user?.id
  });

  const handleSubscribe = () => {
    if (!user?.id || !botId) {
      toast.error("Authentication Error", {
        description: "Please login to use this bot."
      });
      return { success: false };
    }

    setIsSubscribing(true);
    return { success: true };
  };

  const resetSubscribingState = () => {
    setIsSubscribing(false);
  };

  return {
    premiumBot,
    isLoading,
    error,
    isSubscribing,
    subscriptionSuccess,
    handleSubscribe,
    resetSubscribingState,
    refetch
  };
};
